module.exports = __webpack_public_path__ + "img/e-commerce.ac22c9f8.svg";